import type { ProfileNotice } from "../profile-notice";

export function ProfileStatus({ notice }: { notice: ProfileNotice }) {
  return (
    <output
      className={`font-plex-sans inline-flex items-center gap-[6px] text-[16px] leading-[24px] ${notice?.tone === "error" ? "text-[#945637]" : "text-[#5e5e5e]"}`}
    >
      {notice?.tone === "saved" ? (
        <svg
          aria-hidden="true"
          width="12"
          height="10"
          viewBox="0 0 12 10"
          fill="none"
          className="block shrink-0"
        >
          <path
            d="M1 5.2 4.3 8.5 11 1.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : null}
      {notice?.text}
    </output>
  );
}
